import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "bee93c16-c966-4f5e-831c-8ce5a4f95b09",
    content: "Direct sound, early reflections, late reflections",
    options: {},
  },
  {
    id: "f03d3480-23ac-40c5-a914-385d8cbb71fe",
    content: "Absorption, reflection, transmission",
    options: {},
  },
  {
    id: "7bffb437-6b28-4b11-84b4-44b53981cd64",
    content: "Scattering, diffusion, absorption",
    options: {},
  },
  {
    id: "8ec1bc06-7a2a-48e0-a8c5-16f768865855",
    content: "Room, building and architectural acoustics",
    options: {},
  },
  {
    id: "ea11987b-535d-402e-84cf-9d70d852359b",
    content: "Building, room and musical acoustics",
    options: {},
  },
  {
    id: "2173951a-3370-46fa-a910-8c98b93f33db",
    content: "Early and late reflections",
    options: {},
  },
];

export const task: Task = {
  id: "e96debbe-9fa5-4666-b86b-4c206b6e1c74",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bee93c16-c966-4f5e-831c-8ce5a4f95b09"],
};
